const cities = [
  {
    'name': 'New York, NY',
    'slug': '/us/new-york-city-ny/',
  },
  {
    'name': 'Manhattan, NY',
    'slug': '/us/manhattan-ny/',
  },
  {
    'name': 'San Francisco, CA',
    'slug': '/us/san-francisco-ca/',
  },
  {
    'name': 'Austin, TX',
    'slug': '/us/austin-tx/',
  },
  {
    'name': 'Denver, CO',
    'slug': '/us/denver-co/',
  },
  {
    'name': 'Seattle, WA',
    'slug': '/us/seattle-wa/',
  },
  {
    'name': 'San Diego, CA',
    'slug': '/us/san-diego-ca/',
  },
  {
    'name': 'Portland, OR',
    'slug': '/us/portland-or/',
  },
  {
    'name': 'Chicago, IL',
    'slug': '/us/chicago-il/',
  },
  {
    'name': 'Honolulu, HI',
    'slug': '/us/honolulu-hi/',
  },
  {
    'name': 'Tallahassee, Fl',
    'slug': '/us/tallahassee-fl/',
  },
  {
    'name': 'Boston, MA',
    'slug': '/us/boston-ma/',
  },
  {
    'name': 'Dublin, Ireland',
    'slug': '/ie/dublin-l/',
  },
  {
    'name': 'Christchurch, New Zealand',
    'slug': '/nz/christchurch-canterbury/',
  },
  {
    'name': 'Vancouver, Canada',
    'slug': '/ca/vancouver-british-columbia/',
  },
  {
    'name': 'Edinburgh, Scotland',
    'slug': '/gb/edinburgh-sct/',
  },
  {
    'name': 'United States',
    'slug': '/us/',
  },
  {
    'name': 'Find Your City',
    'slug': '/us/',
  },
]

export default cities



// WEBPACK FOOTER //
// ./src/components/landing/find-your-path/cities.js